// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dCoordinates from "../Data.Coordinates/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCountries from "../Restaumatic.Countries/index.js";
import * as Restaumatic$dGeocoding$dTypes$dAddressExtra from "../Restaumatic.Geocoding.Types.AddressExtra/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq4 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Foreign$dInternal$dStringify.unsafeStringify(x._1) === Foreign$dInternal$dStringify.unsafeStringify(y._1); }
    return false;
  }
  return false;
};
const apartmentNumberIsSymbol = {reflectSymbol: () => "apartmentNumber"};
const cityIsSymbol = {reflectSymbol: () => "city"};
const coordinatesIsSymbol = {reflectSymbol: () => "coordinates"};
const countryIsSymbol = {reflectSymbol: () => "country"};
const extraIsSymbol = {reflectSymbol: () => "extra"};
const floorIsSymbol = {reflectSymbol: () => "floor"};
const formattedAddressIsSymbol = {reflectSymbol: () => "formattedAddress"};
const postCodeIsSymbol = {reflectSymbol: () => "postCode"};
const streetIsSymbol = {reflectSymbol: () => "street"};
const streetNumberIsSymbol = {reflectSymbol: () => "streetNumber"};
const showMaybe = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const DeliveryAddressIsSymbol = {reflectSymbol: () => "DeliveryAddress"};
const decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1);
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther1 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const decodeWithOptionsOther1 = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.readString)};
const DeliveryAddress = x => x;
const toFillFormTypeDeliveryAdd = {fillFormDataType: v => "unknown"};
const newtypeDeliveryAddress_ = {Coercible0: () => {}};
const hasFieldDeliveryAddress = dictHasField => dictHasField;
const eqDeliveryAddress = {
  eq: x => y => (() => {
    if (x.apartmentNumber.tag === "Nothing") { return y.apartmentNumber.tag === "Nothing"; }
    if (x.apartmentNumber.tag === "Just") {
      if (y.apartmentNumber.tag === "Just") { return x.apartmentNumber._1 === y.apartmentNumber._1; }
      return false;
    }
    return false;
  })() && x.city === y.city && (() => {
    if (x.coordinates.tag === "Nothing") { return y.coordinates.tag === "Nothing"; }
    if (x.coordinates.tag === "Just") {
      if (y.coordinates.tag === "Just") { return x.coordinates._1.lat === y.coordinates._1.lat && x.coordinates._1.lon === y.coordinates._1.lon; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.country.tag === "PL") { return y.country.tag === "PL"; }
    if (x.country.tag === "GB") { return y.country.tag === "GB"; }
    if (x.country.tag === "RU") { return y.country.tag === "RU"; }
    if (x.country.tag === "RO") { return y.country.tag === "RO"; }
    if (x.country.tag === "CZ") { return y.country.tag === "CZ"; }
    if (x.country.tag === "HR") { return y.country.tag === "HR"; }
    if (x.country.tag === "SK") { return y.country.tag === "SK"; }
    if (x.country.tag === "DE") { return y.country.tag === "DE"; }
    if (x.country.tag === "NL") { return y.country.tag === "NL"; }
    if (x.country.tag === "ES") { return y.country.tag === "ES"; }
    if (x.country.tag === "BR") { return y.country.tag === "BR"; }
    if (x.country.tag === "IT") { return y.country.tag === "IT"; }
    if (x.country.tag === "SI") { return y.country.tag === "SI"; }
    return false;
  })() && eq4(x.extra)(y.extra) && (() => {
    if (x.floor.tag === "Nothing") { return y.floor.tag === "Nothing"; }
    if (x.floor.tag === "Just") {
      if (y.floor.tag === "Just") { return x.floor._1 === y.floor._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.formattedAddress.tag === "Nothing") { return y.formattedAddress.tag === "Nothing"; }
    if (x.formattedAddress.tag === "Just") {
      if (y.formattedAddress.tag === "Just") { return x.formattedAddress._1 === y.formattedAddress._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.postCode.tag === "Nothing") { return y.postCode.tag === "Nothing"; }
    if (x.postCode.tag === "Just") {
      if (y.postCode.tag === "Just") { return x.postCode._1 === y.postCode._1; }
      return false;
    }
    return false;
  })() && x.street === y.street && x.streetNumber === y.streetNumber
};
const genericDeliveryAddress = {to: x => x, from: x => x};
const showDeliveryAddress = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ apartmentNumber: " + showMaybe.show(v.apartmentNumber) + ", city: " + Data$dShow.showStringImpl(v.city) + (() => {
          if (v.coordinates.tag === "Just") {
            return ", coordinates: (Just " + Data$dCoordinates.showCoordinates.show(v.coordinates._1) + ")" + ", country: " + Restaumatic$dCountries.showCountry.show(v.country) + (() => {
              if (v.extra.tag === "Just") {
                return ", extra: (Just " + Restaumatic$dGeocoding$dTypes$dAddressExtra.showAddressExtra.show(v.extra._1) + ")" + ", floor: " + showMaybe.show(v.floor) + ", formattedAddress: " + showMaybe.show(v.formattedAddress) + ", postCode: " + showMaybe.show(v.postCode) + ", street: " + Data$dShow.showStringImpl(v.street) + ", streetNumber: " + Data$dShow.showStringImpl(v.streetNumber) + " ";
              }
              if (v.extra.tag === "Nothing") {
                return ", extra: Nothing, floor: " + showMaybe.show(v.floor) + ", formattedAddress: " + showMaybe.show(v.formattedAddress) + ", postCode: " + showMaybe.show(v.postCode) + ", street: " + Data$dShow.showStringImpl(v.street) + ", streetNumber: " + Data$dShow.showStringImpl(v.streetNumber) + " ";
              }
              $runtime.fail();
            })();
          }
          if (v.coordinates.tag === "Nothing") {
            return ", coordinates: Nothing, country: " + Restaumatic$dCountries.showCountry.show(v.country) + (() => {
              if (v.extra.tag === "Just") {
                return ", extra: (Just " + Restaumatic$dGeocoding$dTypes$dAddressExtra.showAddressExtra.show(v.extra._1) + ")" + ", floor: " + showMaybe.show(v.floor) + ", formattedAddress: " + showMaybe.show(v.formattedAddress) + ", postCode: " + showMaybe.show(v.postCode) + ", street: " + Data$dShow.showStringImpl(v.street) + ", streetNumber: " + Data$dShow.showStringImpl(v.streetNumber) + " ";
              }
              if (v.extra.tag === "Nothing") {
                return ", extra: Nothing, floor: " + showMaybe.show(v.floor) + ", formattedAddress: " + showMaybe.show(v.formattedAddress) + ", postCode: " + showMaybe.show(v.postCode) + ", street: " + Data$dShow.showStringImpl(v.street) + ", streetNumber: " + Data$dShow.showStringImpl(v.streetNumber) + " ";
              }
              $runtime.fail();
            })();
          }
          $runtime.fail();
        })() + "}"
      ]
    })(DeliveryAddressIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeDeliveryAddress = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(apartmentNumberIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(cityIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(coordinatesIsSymbol)(Unscramble.decodeMaybe(Data$dCoordinates.unscrambleDecodeCoordinates))(Unscramble.decodeRecordCons(countryIsSymbol)(Restaumatic$dCountries.unscrambleDecodeCountry)(Unscramble.decodeRecordCons(extraIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dGeocoding$dTypes$dAddressExtra.unscrambleDecodeAddressExtra))(Unscramble.decodeRecordCons(floorIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(formattedAddressIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(postCodeIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(streetIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(streetNumberIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeDeliveryAddress = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericDeliveryAddress)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(DeliveryAddressIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(streetNumberIsSymbol)(encodeWithOptionsOther))(streetIsSymbol)(encodeWithOptionsOther))(postCodeIsSymbol)(encodeWithOptionsOther1))(formattedAddressIsSymbol)(encodeWithOptionsOther1))(floorIsSymbol)(encodeWithOptionsOther1))(extraIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") {
          return Foreign$dGeneric$dClass.genericEncodeConstructor(Restaumatic$dGeocoding$dTypes$dAddressExtra.AddressExtraIsSymbol)({
            encodeArgs: opts => v$1 => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v$1), Data$dList$dTypes.Nil)
          }).encodeOpts(Foreign$dEncoding.options)(v2._1);
        }
        $runtime.fail();
      }
    }))(countryIsSymbol)({encodeWithOptions: v => Restaumatic$dCountries.encodeCountry.encode}))(coordinatesIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Data$dCoordinates.encodeCoordinates.encode(v2._1); }
        $runtime.fail();
      }
    }))(cityIsSymbol)(encodeWithOptionsOther))(apartmentNumberIsSymbol)(encodeWithOptionsOther1);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeDeliveryAddress = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericDeliveryAddress)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(DeliveryAddressIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(streetNumberIsSymbol)(decodeWithOptionsOther)())(streetIsSymbol)(decodeWithOptionsOther)())(postCodeIsSymbol)(decodeWithOptionsOther1)())(formattedAddressIsSymbol)(decodeWithOptionsOther1)())(floorIsSymbol)(decodeWithOptionsOther1)())(extraIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dGeocoding$dTypes$dAddressExtra.decodeAddressExtra.decode)
  })())(countryIsSymbol)({decodeWithOptions: v => Restaumatic$dCountries.decodeCountry.decode})())(coordinatesIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dCoordinates.decodeCoordinates.decode)
  })())(cityIsSymbol)(decodeWithOptionsOther)())(apartmentNumberIsSymbol)(decodeWithOptionsOther1)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  DeliveryAddress,
  DeliveryAddressIsSymbol,
  apartmentNumberIsSymbol,
  cityIsSymbol,
  coordinatesIsSymbol,
  countryIsSymbol,
  decodeDeliveryAddress,
  decodeMaybe,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  encodeDeliveryAddress,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  eq4,
  eqDeliveryAddress,
  extraIsSymbol,
  floorIsSymbol,
  formattedAddressIsSymbol,
  genericDeliveryAddress,
  hasFieldDeliveryAddress,
  newtypeDeliveryAddress_,
  postCodeIsSymbol,
  showDeliveryAddress,
  showMaybe,
  streetIsSymbol,
  streetNumberIsSymbol,
  toFillFormTypeDeliveryAdd,
  unscrambleDecodeDeliveryAddress
};
